export default "__VITE_ASSET__COpPke5U__"